// Environment configuration
// Uses EXPO_PUBLIC_* vars (bundled into web builds) with fallbacks

import Constants from 'expo-constants';
import { Platform } from 'react-native';

const isAndroidEmulator = Platform.OS === 'android' && !Constants.isDevice;

const resolveDevUrl = (url: string): string => {
  if (!isAndroidEmulator) return url;
  try {
    const parsed = new URL(url);
    const isPrivateIp =
      parsed.hostname === 'localhost' ||
      parsed.hostname === '127.0.0.1' ||
      /^(10|172\.(1[6-9]|2\d|3[01])|192\.168)\./.test(parsed.hostname);
    if (isPrivateIp) {
      parsed.hostname = '10.0.2.2';
      return parsed.toString().replace(/\/$/, '');
    }
  } catch {}
  return url;
};

const getEnvironment = (): 'development' | 'preview' | 'production' | 'demo' => {
  const env = process.env.EXPO_PUBLIC_APP_ENV;
  if (env === 'production' || env === 'preview' || env === 'development' || env === 'demo') {
    return env;
  }
  return 'development';
};

const getApiUrl = (): string => {
  // EXPO_PUBLIC_ vars are bundled at build time
  if (process.env.EXPO_PUBLIC_API_URL) {
    return resolveDevUrl(process.env.EXPO_PUBLIC_API_URL);
  }

  // Fallback based on environment
  const env = getEnvironment();
  if (env === 'production') return 'https://api.flavrly.app';
  if (env === 'preview') return 'https://api-preview.flavrly.app';
  if (env === 'demo') return 'https://api-demo.flavrly.app';
  return resolveDevUrl('http://localhost:8787');
};

const getAuthUrl = (): string => {
  // EXPO_PUBLIC_ vars are bundled at build time
  if (process.env.EXPO_PUBLIC_AUTH_URL) {
    return resolveDevUrl(process.env.EXPO_PUBLIC_AUTH_URL);
  }

  // Fallback based on environment
  const env = getEnvironment();
  if (env === 'production') return 'https://auth.flavrly.app';
  if (env === 'preview') return 'https://auth-preview.flavrly.app';
  if (env === 'demo') return 'https://auth-demo.flavrly.app';
  return resolveDevUrl('http://localhost:8788');
};

const getUploadUrl = (): string => {
  const env = getEnvironment();
  if (env === 'production') return 'https://upload.flavrly.app';
  if (env === 'preview') return 'https://upload-preview.flavrly.app';
  if (env === 'demo') return 'https://upload-demo.flavrly.app';
  return '';
};

const API_URL = getApiUrl();

export const ENV = {
  APP_ENV: getEnvironment(),
  API_URL,
  AUTH_URL: getAuthUrl(),
  UPLOAD_URL: getUploadUrl(),
  WS_URL: API_URL.replace(/^http/, 'ws'),
} as const;

